import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import "./style.css";
import { fetchEmployeeApi } from "../../../api/api";
import { useOrganizationId } from "../../../context/Customfunction";
import CustomFeed from "../../../ui/custom-feed";
import CustomButton from "../../../ui/custom-button";

function CameraFeedPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { camera } = useSelector((state) => state?.LiveFeed?.cameraFeed || {});
  ////console("camera", camera);
  const [empdata, setEmpdata] = useState([]);
  const orgId = useOrganizationId();

  const [streamData, setStreamData] = useState(camera || []);

  useEffect(() => {
    setStreamData(camera || []);
    fetchEmployee();
  }, [camera]);

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );

    navigate("/camera");
  };

  const fetchEmployee = async () => {
    try {
      const fetchemployee = await fetchEmployeeApi(orgId);
      ////console("fetchemployee", fetchemployee);
      if (fetchemployee?.data?.status === true) {
        setEmpdata(fetchemployee?.data?.employees);
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const selectEmployee = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "EmployeeList",
        showModal: true,
        data: empdata,
      })
    );
  };

  return (
    <div className="camera-feed-page">
      <div className="header">
        <h2>Camera Streams</h2>

        <div className="d-flex justify-content-end gap-3 mb-4">
          <CustomButton
            className="mainBlue py-2 px-4 ms-3"
            onClick={handleClose}
          >
            Close
          </CustomButton>
          <CustomButton
            className="mainBlue py-2 px-4 ms-3"
            onClick={() => selectEmployee()}
          >
            Employees
          </CustomButton>
        </div>
      </div>

      <CustomFeed streamData={streamData} />
    </div>
  );
}

export default CameraFeedPage;
